import { IQuizAnswerSubmission, IQuizQuestionsResult } from "../IUnitResultModel";

export const questionsQuizResultToPassDTO = ({ answersIds, pseudoId }: IQuizQuestionsResult): IQuizAnswerSubmission => ({
  pseudoId,
  answersIds,
})

export const questionsQuizResultToPassDTOList = (list) => list.map(questionsQuizResultToPassDTO);